import React, { Fragment } from "react";
import { Student } from "../types";
import { useTranslation } from "react-i18next";
import { Table, Segment, Button, Label, Icon } from "semantic-ui-react";
import GenderImage from "../../../components/GenderImage";
import { formatGradeWithSuffix } from "../../../app/helpers/gradeHelpers";
import ButtonLink from "../../../components/ButtonLink";

interface IProps {
  pendingRegistrations: Student[];
  handleApprove: (studentId: number) => void;
  handleReject: (studentId: number) => void;
  handleDelete: (studentId: number) => void;
  sort: { column: string; direction: "asc" | "desc" } | null;
  onSortChange: (column: string) => void;
}

const PendingRegistrations: React.FC<IProps> = ({
  pendingRegistrations,
  handleApprove,
  handleReject,
  handleDelete,
  sort,
  onSortChange,
}) => {
  const { t } = useTranslation();

  const getSortIcon = () => {
    if (sort?.column !== "createdOn") return "sort";
    return sort.direction === "asc" ? "sort up" : "sort down";
  };

  return (
    <Fragment>
      <Segment placeholder padded className="pending-registrations-segment">
        <div className="pending-registrations">
          <div className="pending-registrations-text">
            {t("pending_list.title")}: {pendingRegistrations.length}
          </div>
          <Table basic="very" className="student-list pending" sortable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{t("common.student")}</Table.HeaderCell>
                <Table.HeaderCell>{t("common.phone")}</Table.HeaderCell>
                <Table.HeaderCell>{t("common.email")}</Table.HeaderCell>
                <Table.HeaderCell
                  sorted={
                    sort?.column === "createdOn" ? (sort.direction === "asc" ? "ascending" : "descending") : undefined
                  }
                  onClick={() => onSortChange("createdOn")}
                  style={{ cursor: "pointer" }}
                >
                  {t("common.registration_date")} <Icon name={getSortIcon() as any} />
                </Table.HeaderCell>
                <Table.HeaderCell />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {pendingRegistrations.map((student: Student) => (
                <Table.Row key={student.id}>
                  <Table.Cell>
                    <GenderImage gender={student.gender} />
                    {student.contactInfo.fullName}, {formatGradeWithSuffix(student.grade, student.isStudent)}
                  </Table.Cell>
                  <Table.Cell>
                    <a href={"tel:" + student.contactInfo.phoneNumber}>{student.contactInfo.phoneNumber}</a>
                  </Table.Cell>
                  <Table.Cell>
                    <a href={"mailto:" + student.contactInfo.email}>{student.contactInfo.email}</a>
                  </Table.Cell>
                  <Table.Cell>{new Date(student.createdOn).toLocaleDateString("lt-LT")}</Table.Cell>
                  <Table.Cell className="student-list-actions" singleLine>
                    {student.emailConfirmed ? (
                      <>
                        <Button
                          primary
                          content={t("pending_list.actions.approve")}
                          onClick={() => handleApprove(student.id)}
                        />
                        <Button
                          primary
                          negative
                          content={t("pending_list.actions.reject")}
                          onClick={() => handleReject(student.id)}
                        />
                      </>
                    ) : (
                      <>
                        <Label style={{ backgroundColor: "#EB5757" }}>
                          <Icon name="mail" />
                          {t("pending_list.email_not_confirmed")}
                        </Label>
                        <ButtonLink onClick={() => handleDelete(student.id)}>
                          {t("pending_list.actions.remove")}
                        </ButtonLink>
                      </>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </Segment>
    </Fragment>
  );
};

export default PendingRegistrations;
